<template>
  <div>
    <DropdownMenu>
      <DropdownMenuTrigger as-child>
        <div :class="isMobile ? 'mobile-section' : 'section'">
          <div class="content">
            <svg-icon v-if="isMobile" name="huge-earth" class="w-5 h-5" />

            <div
              v-if="!isMobile"
              class="flex items-center justify-center text-sm font-medium"
            >
              {{ selectedLocaleTitle }}
            </div>
          </div>
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent :class="isMobile ? 'mobile-menu' : 'menu'">
        <DropdownMenuItem
          v-for="loc in $options.locales"
          :key="loc.id"
          @click="setLocale(loc.locale)"
          :class="loc.locale === currentLocale ? 'text-muted-foreground' : ''"
        >
          {{ loc.shortTitle }}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  </div>
</template>

<script>
import { locales } from "@/shared/config/i18n";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/shared/ui/dropdown-menu";

export default {
  name: "LangSelection",
  components: {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  locales,
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
    selectedLocale() {
      let locale = null;
      if (this.currentLocale) {
        locale = this.$options.locales.find(
          (l) => l.locale === this.currentLocale
        );
      }
      return locale;
    },
    selectedLocaleTitle() {
      return this.selectedLocale
        ? this.selectedLocale.locale.toUpperCase()
        : "";
    },
  },
  methods: {
    async setLocale(locale) {
      if (locale) {
        this.$i18n.locale = locale;
        localStorage.setItem("lang", locale);
        window.location.reload();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.section {
  @apply inline-flex items-center justify-center rounded-md  transition-colors outline-none text-muted-foreground cursor-pointer;
  &:hover {
    @apply text-foreground;
  }
}

.mobile-section {
  @apply w-10 h-10 rounded-full flex flex-col items-center justify-center gap-1;
  @apply bg-card outline outline-1 outline-border;

  svg {
    @apply w-5 h-5;
  }
}

.content {
  @apply inline-flex h-8 w-8 items-center justify-center rounded-md border border-border bg-background transition-colors outline-none text-gray-500;

  &:hover {
    @apply text-gray-900;
    background-color: rgb(var(--color-gray-100));
  }
}

.menu {
  @apply w-40 p-2 bg-card rounded-xl flex flex-col gap-2 outline outline-1 outline-offset-[-1px];
}
</style>
